
import React from 'react';
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "@/components/ui/table";
import { CashflowResult } from '../data/forecastingData';

interface ScenarioResultsTableProps {
  results: CashflowResult[];
}

const ScenarioResultsTable = ({ results }: ScenarioResultsTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Time Horizon</TableHead>
          <TableHead className="text-right">Baseline (₹ Cr)</TableHead>
          <TableHead className="text-right">Stressed (₹ Cr)</TableHead>
          <TableHead className="text-right">Severe (₹ Cr)</TableHead>
          <TableHead className="text-right">Recovery (₹ Cr)</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {results.map((item) => (
          <TableRow key={item.horizon}>
            <TableCell>{item.horizon}</TableCell>
            <TableCell className="text-right font-medium">{item.baseline}</TableCell>
            <TableCell className={`text-right ${parseFloat(item.stressed) < 0 ? 'text-red-500' : 'text-green-500'}`}>
              {item.stressed}
            </TableCell>
            <TableCell className={`text-right ${parseFloat(item.severe) < 0 ? 'text-red-500' : 'text-green-500'}`}>
              {item.severe}
            </TableCell>
            <TableCell className={`text-right ${parseFloat(item.recovery) < 0 ? 'text-red-500' : 'text-green-500'}`}>
              {item.recovery}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ScenarioResultsTable;
